// header follow us dropdown
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.follow-us-dropdown').forEach(function (dropdown) {

    const toggle = dropdown.querySelector('.follow-us-toggle');

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();

      // Close other dropdowns
      document.querySelectorAll('.follow-us-dropdown.is-open').forEach(function (item) {
        if (item !== dropdown) {
          item.classList.remove('is-open');
        }
      });

      dropdown.classList.toggle('is-open');
    });

  });

  // Close when clicking outside
  document.addEventListener('click', function () {
    document.querySelectorAll('.follow-us-dropdown.is-open').forEach(function (dropdown) {
      dropdown.classList.remove('is-open');
    });
  });

});


// choose your place slider js
$(document).ready(function () {


  function setCypSliderHeight() {
    $('.choose-your-place').each(function () {
      var $section = $(this);
      var $tabs = $section.find('.cyp-tabs');
      var $slider = $section.find('.cyp-slider');

      if (!$tabs.length || !$slider.hasClass('slick-initialized')) {
        return;
      }

      var tabsHeight = $tabs.outerHeight();

      // Set same height on Slick wrapper/list/track/slides
      $slider.find('.slick-list').css('height', tabsHeight + 'px');
      $slider.find('.slick-track').css('height', tabsHeight + 'px');
      $slider.find('.slick-slide').css('height', tabsHeight + 'px');

      // Also set slider itself
      $slider.css('height', tabsHeight + 'px');
    });
  }


  function choose_your_place_slider() {
      $('.cyp-slider').each(function () {
        var $slider = $(this);

        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

        $slider.slick({
          vertical: true,
          infinite: false,
          arrows: false,
          dots: false,
          fade: false,
          speed: 900,
          cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,

          swipe: false,
          draggable: false,
          touchMove: false,
          verticalSwiping: false,

          waitForAnimate: false
        });

        var $tabs = $slider
          .closest('.choose-your-place')
          .find('.cyp-tabs__item');

        $tabs.off('.cypSlider');

        $tabs.on('click.cypSlider', function (e) {
          e.preventDefault();

          var $this = $(this);
          var index = parseInt($this.attr('data-slide-index'), 10);

          $tabs.removeClass('cyp-tabs__item--active');
          $this.addClass('cyp-tabs__item--active');

          $slider.slick('slickGoTo', index);
        });

        // Set height after Slick initialization
        setCypSliderHeight();
      });
    }

    // Initial load
    choose_your_place_slider();
    // Resize
    $(window).on('resize.cypSlider', function () {
      setCypSliderHeight();
    });
    // Shopify section reload
    document.addEventListener('shopify:section:load', function () {
      choose_your_place_slider();

      // Wait for layout to settle
      setTimeout(function () {
        setCypSliderHeight();
      }, 50);
    });

});

$(document).on('click', '.cyp-tabs__item', function () {
  if ($(window).width() <= 749) {
    var $target = $('.cyp-slider-wrap');

    if ($target.length) {
      var offset = 20; // Space above the section

      $('html, body').animate({
        scrollTop: $target.offset().top - offset
      }, 600);
    }
  }
});


// Product Media JS 
(function () {
  const mq = window.matchMedia('(min-width: 768px)');

  function enable(sc) {
    if (sc._vt) return;
    const list = sc.querySelector('.thumbnail-list');
    const oldPrev = sc.querySelector('.slider-button--prev');
    const oldNext = sc.querySelector('.slider-button--next');
    if (!list || !oldPrev || !oldNext) return;

    // clones have no Dawn listeners, so only ours run
    const prev = oldPrev.cloneNode(true);
    const next = oldNext.cloneNode(true);
    oldPrev.replaceWith(prev);
    oldNext.replaceWith(next);

    const isV = () => getComputedStyle(list).flexDirection === 'column';

    function itemStep() {
      const li = Array.from(list.querySelectorAll('.thumbnail-list__item')).filter(
        (el) => el.offsetParent !== null
      );
      if (li.length < 2) return 0;
      const a = li[0].getBoundingClientRect();
      const b = li[1].getBoundingClientRect();
      return isV() ? b.top - a.top : b.left - a.left;
    }

    function sync() {
      const v = isV();
      const pos = v ? list.scrollTop : list.scrollLeft;
      const max = v ? list.scrollHeight - list.clientHeight : list.scrollWidth - list.clientWidth;
      prev.toggleAttribute('disabled', pos <= 1);
      next.toggleAttribute('disabled', pos >= max - 1);
    }

    function onClick(e) {
      e.preventDefault();
      const btn = e.currentTarget;
      const dir = btn.name === 'next' ? 1 : -1;
      const step = (Number(btn.dataset.step) || 1) * itemStep() * dir;
      list.scrollBy(isV() ? { top: step, behavior: 'smooth' } : { left: step, behavior: 'smooth' });
    }

    function revealActive() {
      const active = list.querySelector('[aria-current="true"], [aria-current="step"]');
      const li = active && active.closest('.thumbnail-list__item');
      if (!li) return;
      const l = list.getBoundingClientRect();
      const r = li.getBoundingClientRect();
      if (isV()) {
        if (r.top < l.top || r.bottom > l.bottom) {
          list.scrollTo({ top: list.scrollTop + (r.top - l.top), behavior: 'smooth' });
        }
      } else if (r.left < l.left || r.right > l.right) {
        list.scrollTo({ left: list.scrollLeft + (r.left - l.left), behavior: 'smooth' });
      }
    }

    const observer = new MutationObserver(revealActive);
    observer.observe(list, { attributes: true, attributeFilter: ['aria-current'], subtree: true });

    prev.addEventListener('click', onClick);
    next.addEventListener('click', onClick);
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    sc._vt = { list, oldPrev, oldNext, prev, next, observer, sync, onClick };
    setTimeout(sync, 100);
    sync();
  }

  function disable(sc) {
    const s = sc._vt;
    if (!s) return;
    s.observer.disconnect();
    s.list.removeEventListener('scroll', s.sync);
    window.removeEventListener('resize', s.sync);
    s.prev.removeEventListener('click', s.onClick);
    s.next.removeEventListener('click', s.onClick);

    // put Dawn's original buttons back
    s.prev.replaceWith(s.oldPrev);
    s.next.replaceWith(s.oldNext);
    sc._vt = null;

    // nudge Dawn so it refreshes its own disabled state
    s.list.dispatchEvent(new Event('scroll'));
  }

  function apply() {
    document.querySelectorAll('slider-component[id^="GalleryThumbnails"]').forEach((sc) => {
      mq.matches ? enable(sc) : disable(sc);
    });
  }

  function init() {
    apply();
    mq.addEventListener('change', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



//Related Product slider
function related_product_slider() {
  $('.related-products .grid.product-grid').each(function () {
    var $slider = $(this);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    $slider.slick({
      infinite: false,
      arrows: true,
      dots: false,
      fade: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1299, settings: { slidesToShow: 3 } },
        { breakpoint: 749, settings: { slidesToShow: 2 } },
        { breakpoint: 550, settings: { slidesToShow: 1 } }
      ]
    });
  });
}
// Check if slider already exists
function initRelatedProductSlider() {
  if ($('.related-products .grid.product-grid').length) {
    related_product_slider();
    return true;
  }
  return false;
}

// Initial check
initRelatedProductSlider();

// Watch for dynamically added related-products section
var relatedProductObserver = new MutationObserver(function (mutations, observer) {
  if ($('.related-products .grid.product-grid').length) {
    related_product_slider();

    // Stop observing after slider is initialized
    observer.disconnect();
  }
});

relatedProductObserver.observe(document.body, {
  childList: true,
  subtree: true
});


// Shopify section reload
document.addEventListener('shopify:section:load', function () {
  setTimeout(function () {
    initRelatedProductSlider();
  }, 100);
});


// take closer look accordion js 

document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.take-a-closer-look');
    if (!sections.length) return;
    sections.forEach(function (section) {
      const items = section.querySelectorAll(
        '.take-a-closer-look__item'
      );
      const image = section.querySelector(
        '.take-a-closer-look__image'
      );
      if (!items.length || !image) return;

      function updateImage(item) {
        const imageUrl = item.getAttribute('data-img');
        if (!imageUrl) return;
        image.style.opacity = '0';
        setTimeout(function () {
          image.src = imageUrl;
          image.removeAttribute('srcset');
          image.onload = function () {
            image.style.opacity = '1';
          };
        }, 150);
      }


      /*
       * Set first accordion image on page load
       */
      const activeItem = section.querySelector(
        '.take-a-closer-look__item.is-active'
      );
      if (activeItem) {
        const firstImage = activeItem.getAttribute('data-img');
        if (firstImage) {
          image.src = firstImage;
          image.removeAttribute('srcset');
        }
      }

      /*
       * Accordion click
       */
      items.forEach(function (item) {
        const trigger = item.querySelector(
          '.take-a-closer-look__trigger'
        );
        const icon = item.querySelector(
          '.take-a-closer-look__icon'
        );
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          const isActive = item.classList.contains('is-active');
          /*
           * Close all accordion items
           */
          items.forEach(function (accordionItem) {
            accordionItem.classList.remove('is-active');
            const accordionTrigger =
              accordionItem.querySelector(
                '.take-a-closer-look__trigger'
              );
            const accordionIcon =
              accordionItem.querySelector(
                '.take-a-closer-look__icon'
              );

            if (accordionTrigger) {
              accordionTrigger.setAttribute(
                'aria-expanded',
                'false'
              );
            }

            if (accordionIcon) {
              accordionIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                          <path opacity="0.5" d="M6.04805 13.6961C5.77071 13.6961 5.63205 13.4935 5.63205 13.0881V8.03214H0.608047C0.24538 8.03214 0.0427137 7.89347 4.69685e-05 7.61614L0.032047 6.08014C0.032047 5.80281 0.224047 5.66414 0.608047 5.66414H5.63205V0.60814C5.63205 0.202807 5.77071 0.00014019 6.04805 0.00014019H7.64805C7.92538 0.00014019 8.06405 0.202807 8.06405 0.60814V5.66414L13.12 5.63214C13.504 5.63214 13.696 5.77081 13.696 6.04814V7.61614C13.696 7.89347 13.504 8.03214 13.12 8.03214H8.09605V13.0881C8.09605 13.4935 7.94671 13.6961 7.64805 13.6961H6.04805Z" fill="#1D1E23"/>
                                          </svg>`;
            }

          });
          /*
           * Open clicked accordion
           */
          if (!isActive) {
            item.classList.add('is-active');
            trigger.setAttribute(
              'aria-expanded',
              'true'
            );

            if (icon) {
              icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="2" viewBox="0 0 12 2" fill="none">
                            <path opacity="0.5" d="M0.544199 1.98435C0.181533 1.98435 0.000199318 1.79235 0.000199318 1.40835V0.544351C0.000199318 0.181684 0.181533 0.000350952 0.544199 0.000350952H10.7522C11.1149 0.000350952 11.2962 0.181684 11.2962 0.544351V1.40835C11.2962 1.79235 11.1149 1.98435 10.7522 1.98435H0.544199Z" fill="#1D1E23"/>
                            </svg>`;
            }
            /*
             * Change right-side image
             */
            updateImage(item);
          }

        });
      });
    });
  });


// choose your packages

document.addEventListener('DOMContentLoaded', function () {
  const packages = document.querySelectorAll('.product-package-section__package');
  const mainImg = document.querySelector('.product-package-section__image img');

  if (!mainImg || !packages.length) return;

  packages.forEach(function (pack) {
    pack.addEventListener('click', function () {
      const newSrc = this.getAttribute('data-pack-img');
      if (!newSrc) return;

      // Update the main image
      mainImg.setAttribute('src', newSrc);
      mainImg.removeAttribute('srcset'); // Shopify themes often set srcset, which overrides src

      // Move the active class to the clicked package
      packages.forEach(function (p) {
        p.classList.remove('active-package');
      });
      this.classList.add('active-package');
    });
  });
});

//stats js
document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.program-stats');

    if (!sections.length) return;

    const animateNumber = (element) => {
        const target = parseInt(element.textContent.replace(/,/g, ''), 10);

        if (isNaN(target)) return;

        const duration = 2000;
        const startTime = performance.now();

        function updateNumber(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = 1 - Math.pow(1 - progress, 3);
            const currentValue = Math.floor(target * easedProgress);

            element.textContent = currentValue.toLocaleString();

            if (progress < 1) {
                requestAnimationFrame(updateNumber);
            } else {
                element.textContent = target.toLocaleString();
            }
        }

        requestAnimationFrame(updateNumber);
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.querySelectorAll('.program-stats__value')
                    .forEach(animateNumber);

                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.3
    });

    sections.forEach(section => observer.observe(section));
});


//

(function ($) {
  function initBeekeeperSlider(context) {
    $(context).find('.meet .beekeeper-track').addBack('.beekeeper-track').each(function () {
      const $slider = $(this);
      const $section = $slider.closest('.meet');

      if ($slider.hasClass('slick-initialized')) return;

      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        prevArrow: $section.find('.carousel-arrow.prev'),
        nextArrow: $section.find('.carousel-arrow.next'),
        dots: false,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 880,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  }

  $(document).ready(function () {
    initBeekeeperSlider(document);
  });

  $(document).on('shopify:section:load', function (event) {
    initBeekeeperSlider(event.target);
  });
})(jQuery);
